const endpoints = {
  GET_FEEDBACKS: (threadId: string) => `/chat-threads/${threadId}/feedbacks`,
  POST_FEEDBACK: (threadId: string) => `/chat-threads/${threadId}/feedbacks`,
};

export default endpoints;
